<template>
    <div id="bst-wrap">
      <div class="l-project-wrap l-project-wrap--mypage is-hide">

        <Header />

        <section class="l-content-area">
          <div class="l-content">

            <!-- MYPAGE -->
            <section class="p-bloc p-bloc--mypage">
              <div class="p-bloc__content l-wrap__outer">
                <div class="l-wrap__inner">

                  <section class="p-mypage">

                    <!-- Mypage Menu -->
                    <NavbarMyPage/>
                    <!-- Side Menu -->
                    <SideMenu/>

                    <!-- Mypage Content -->
                    <div class="p-mypage__content">
                      <div class="mypage-content">

                        <!-- page -->
                        <div class="p-mypage__page mypage-bloc">
                          <div class="mypage-bloc__content">

                            <!-- page - kiyaku -->
                            <div class="page__bloc page__bloc--kojinjoho c-kiyaku">
                              <h1>{{ $t('LABEL_HANDLING_OF_PERSONAL_DATA') }}</h1>

                              <p>{{ $t('TEXT_PERSONAL_INFORMATION_1') }}<a href="/privacypolicy">{{ $t('TEXT_PERSONAL_INFORMATION_2') }}</a>{{ $t('TEXT_PERSONAL_INFORMATION_3') }}</p>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_4') }}</h2>
                              <p v-html="$t('TEXT_PERSONAL_INFORMATION_5')"></p>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_6') }}</h2>
                              <p v-html="$t('TEXT_PERSONAL_INFORMATION_7')"></p>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_8') }}</h2>
                              <p>{{ $t('TEXT_PERSONAL_INFORMATION_9') }}</p>
                              <h3>{{ $t('TEXT_PERSONAL_INFORMATION_10') }}</h3>
                              <table>
                                <tbody>
                                  <tr>
                                    <th>{{ $t('TEXT_PERSONAL_INFORMATION_11') }}</th>
                                    <td>{{ $t('TEXT_PERSONAL_INFORMATION_12') }}</td>
                                  </tr>
                                  <tr>
                                    <th>{{ $t('TEXT_PERSONAL_INFORMATION_13') }}</th>
                                    <td>{{ $t('TEXT_PERSONAL_INFORMATION_14') }}</td>
                                  </tr>
                                  <tr>
                                    <th>{{ $t('TEXT_PERSONAL_INFORMATION_15') }}</th>
                                    <td>{{ $t('TEXT_PERSONAL_INFORMATION_16') }}</td>
                                  </tr>
                                  <tr>
                                    <th>{{ $t('TEXT_PERSONAL_INFORMATION_17') }}</th>
                                    <td>{{ $t('TEXT_PERSONAL_INFORMATION_18') }}</td>
                                  </tr>
                                  <tr>
                                    <th>{{ $t('TEXT_PERSONAL_INFORMATION_19') }}</th>
                                    <td>{{ $t('TEXT_PERSONAL_INFORMATION_20') }}</td>
                                  </tr>
                                  <tr>
                                    <th>{{ $t('TEXT_PERSONAL_INFORMATION_21') }}</th>
                                    <td v-html="$t('TEXT_PERSONAL_INFORMATION_22')"></td>
                                  </tr>
                                  <tr>
                                    <th>{{ $t('TEXT_PERSONAL_INFORMATION_23') }}</th>
                                    <td>{{ $t('TEXT_PERSONAL_INFORMATION_24') }}</td>
                                  </tr>
                                </tbody>
                              </table>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_25') }}</h2>
                              <p>{{ $t('TEXT_PERSONAL_INFORMATION_26') }}</p>
                              <ol class="paren">
                                <li>{{ $t('TEXT_PERSONAL_INFORMATION_27') }}</li>
                                <li>{{ $t('TEXT_PERSONAL_INFORMATION_28') }}</li>
                                <li>{{ $t('TEXT_PERSONAL_INFORMATION_29') }}<br>{{ $t('TEXT_PERSONAL_INFORMATION_30') }}<br>
                                  <ul>
                                    <li>{{ $t('TEXT_PERSONAL_INFORMATION_31') }}</li>
                                    <li>{{ $t('TEXT_PERSONAL_INFORMATION_32') }}</li>
                                    <li>{{ $t('TEXT_PERSONAL_INFORMATION_33') }}</li>
                                    <li>{{ $t('TEXT_PERSONAL_INFORMATION_34') }}</li>
                                  </ul>
                                </li>
                                <li>{{ $t('TEXT_PERSONAL_INFORMATION_35') }}<br>
                                    {{ $t('TEXT_PERSONAL_INFORMATION_36') }}<br>
                                  <ul>
                                    <li>{{ $t('TEXT_PERSONAL_INFORMATION_37') }}</li>
                                    <li>{{ $t('TEXT_PERSONAL_INFORMATION_38') }}</li>
                                  </ul>
                                </li>
                              </ol>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_39') }}</h2>
                              <p>{{ $t('TEXT_PERSONAL_INFORMATION_40') }}</p>
                              <h4>{{ $t('TEXT_PERSONAL_INFORMATION_41') }}</h4>
                              <p>{{ $t('TEXT_PERSONAL_INFORMATION_42') }}<br>
                                {{ $t('TEXT_PERSONAL_INFORMATION_43') }}<br>
                                {{ $t('TEXT_PERSONAL_INFORMATION_44') }}<a href="https://hubsynch.com/contactus/">https://hubsynch.com/contactus/</a></p>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_45') }}</h2>
                              <p>{{ $t('TEXT_PERSONAL_INFORMATION_46') }}</p>
                              <ol class="paren">
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_47')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_48')"></li>
                              </ol>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_49') }}</h2>
                              <p>{{ $t('TEXT_PERSONAL_INFORMATION_50') }}</p>
                              <ol class="paren">
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_51')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_52')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_53')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_54')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_55')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_56')"></li>
                              </ol>
                              <h5>{{ $t('TEXT_PERSONAL_INFORMATION_57') }}</h5>
                              <p><a href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku" target="_blank">https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku</a></p>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_58') }}</h2>
                              <ol>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_59')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_60')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_61')"></li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_62')"></li>
                              </ol>

                              <h2>{{ $t('TEXT_PERSONAL_INFORMATION_63') }}</h2>
                              <p>{{ $t('TEXT_PERSONAL_INFORMATION_64') }}</p>
                              <ol>
                                <li>{{ $t('TEXT_PERSONAL_INFORMATION_65') }}</li>
                                <li v-html="$t('TEXT_PERSONAL_INFORMATION_66')"></li>
                                <li>{{ $t('TEXT_PERSONAL_INFORMATION_67') }}</li>
                              </ol>

                              <p class="right-side" v-html="$t('TEXT_PERSONAL_INFORMATION_76')"></p>

                            </div>


                          </div>
                        </div>

                      </div><!-- .mypage-content -->
                    </div>

                  </section>

                </div>
              </div>
            </section>


          </div><!-- .l-content -->
        </section><!-- .l-content-area -->

      </div><!-- .l-project-wrap -->

      <Footer/>
    </div>
</template>
<script setup>
import NavbarMyPage from "@/components/NavbarMyPage.vue";
import Footer from "@/components/Footer.vue";
import SideMenu from "@/components/SideMenu.vue";
import Header from "@/components/Header.vue";
</script>